const firebaseConfig = {
    apiKey: "AIzaSyDaNSMy5_rBN_TXXk63xFS6E5NjO9WSzeE",
    authDomain: "my-portfolio-2067e.firebaseapp.com",
    // databaseURL: "https://aplikasi-penjualan-986e3.firebaseio.com",
    projectId: "my-portfolio-2067e",
    storageBucket: "my-portfolio-2067e.appspot.com",
    messagingSenderId: "892792457864",
    appId: "1:892792457864:web:5b57ef2e4cde8f69b86d3d",
    // measurementId: "G-WH9ZY0NECV"
};

export default firebaseConfig;
